// Bộ lọc "Từ ngày – Đến ngày" trên Boss web (Lịch sử chạy, Thống kê, So sánh Boss, Việc đã làm) — câu báo lỗi DÙNG CHUNG cho máy chủ và trang
// (L-79: trước đây máy chủ báo "from phải trước to" — tên biến tiếng Anh hiện thẳng cho người dùng; trang Việc đã làm không báo gì).
export const MSG_KHOANG_NGAY = "“Từ ngày” phải trước hoặc bằng “Đến ngày”";

export const MSG_NGAY_KHONG_HOP_LE = "Ngày lọc không hợp lệ — hãy chọn một ngày có thật, năm gồm 4 chữ số (0001–9999)";

/** Ngày dạng YYYY-MM-DD (năm đúng 4 chữ số) có THẬT trên lịch và đổi được sang mốc thời gian. Ô <input type=date> của trình duyệt nhận cả năm
 * tới 275760 ("275760-09-13") — chuỗi đó không phải ISO mà Date hiểu nên new Date(...).toISOString() ném RangeError "Invalid time value" (11/10). */
function ngayDungDuoc(v: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(v) && ngayCoThat(v) && !Number.isNaN(Date.parse(`${v}T00:00:00+07:00`));
}

/** Kiểm hai ô ngày dạng YYYY-MM-DD của trình duyệt (ô trống = không lọc phía đó). Trả câu lỗi hoặc null.
 * PHẢI gọi TRƯỚC mọi chỗ đổi ngày sang ISO (dauNgayVN / cuoiNgayVN / filters()). */
export function kiemKhoangNgay(tu: string, den: string): string | null {
  if ((tu && !ngayDungDuoc(tu)) || (den && !ngayDungDuoc(den))) return MSG_NGAY_KHONG_HOP_LE;
  return tu && den && tu > den ? MSG_KHOANG_NGAY : null;
}

/** 00:00:00.000 ngày `v` theo giờ Việt Nam (+07:00) dạng ISO. Rỗng hoặc không biểu diễn được → undefined (KHÔNG ném lỗi). */
export function dauNgayVN(v: string): string | undefined {
  return v && ngayDungDuoc(v) ? new Date(`${v}T00:00:00+07:00`).toISOString() : undefined;
}

/** 23:59:59.999 ngày `v` theo giờ Việt Nam (+07:00) dạng ISO. Rỗng hoặc không biểu diễn được → undefined (KHÔNG ném lỗi). */
export function cuoiNgayVN(v: string): string | undefined {
  return v && ngayDungDuoc(v) ? new Date(`${v}T23:59:59.999+07:00`).toISOString() : undefined;
}

/** Chuỗi bắt đầu bằng YYYY-MM-DD thì ngày đó phải CÓ THẬT trên lịch (29/02 chỉ năm nhuận, không 30/02, 31/04…). V8 Date.parse("2026-02-30")
 * lặng lẽ ra 02/03 → bộ lọc sai mà không ai biết (test toàn diện 03/10). Không theo dạng đó → true (để Date.parse quyết như cũ). */
export function ngayCoThat(s: string): boolean {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s.trim());
  if (!m) return true;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const dt = new Date(0);
  dt.setUTCFullYear(y, mo - 1, d); // KHÔNG dùng Date.UTC(y, …): năm 0–99 bị hiểu thành 1900+y ("0001-01-01" bị coi là không có thật)
  return dt.getUTCFullYear() === y && dt.getUTCMonth() === mo - 1 && dt.getUTCDate() === d;
}
